module.exports = __webpack_public_path__ + "img/vc.36f451ed.svg";